// declares Profile action types.

import ProfileConst from '../constants/profile.constants';

export const CustomUserAddAttributesValue = (catId, cusId, value) => ({
  type: ProfileConst.CUSTOM_USER_ATTRIBUTES_VALUE,
  catId,
  cusId,
  value,
});

export const AddUserTimeOff = item => ({
  type: ProfileConst.ADD_USER_TIME_OFF,
  value: item,
});

export const UpdateUserTimeOff = (tempid, item) => ({
  type: ProfileConst.UPDATE_USER_TIME_OFF,
  tempid,
  value: item,
});

export const DeleteUserTimeOff = id => ({
  type: ProfileConst.DELETE_USER_TIME_OFF,
  id,
});
